import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  IUploadDealerMetricsParams,
  UploadResponseDto,
} from "~/entity/Uploads/model/schema";

const uploadServiceMap = {
  uploadValue: "/uploads/upload-values",
  acceptUpload: "/uploads/accept-upload-values",
  rejectFile: "/uploads/reject-upload-values",
  userToDealerTemplate: "/uploads/template/user-to-dealer",
};

export class UploadsService {
  static POST = {
    acceptFile: (
      uploadId: string | number | bigint,
    ): NetworkResponse<unknown> =>
      requestREST.post(uploadServiceMap.acceptUpload, { uploadId }),
    rejectFile: (
      uploadId: string | number | bigint,
    ): NetworkResponse<unknown> =>
      requestREST.post(uploadServiceMap.rejectFile, { uploadId }),
    uploadDealerMetrics: (
      data: IUploadDealerMetricsParams,
    ): NetworkResponse<UploadResponseDto> =>
      requestREST.post(uploadServiceMap.uploadValue, data),
  };

  static GET = {
    // PASDILER-1964: CSV-шаблон прикрепления региональных менеджеров.
    // Бэк отдаёт text/csv; качаем как blob и сохраняем через URL.
    userToDealerTemplate: (): Promise<Blob> =>
      requestREST
        .get(uploadServiceMap.userToDealerTemplate, {
          responseType: "blob",
        })
        .then((res) => res.data as Blob),
  };
}
